export default "__VITE_ASSET__Dhl7YRfd__"